import { useEffect, useState } from "react";
import { viewAllCompany } from "../services/commonServices";

export const useCompanyFilter = () => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await viewAllCompany();
        const formatted = response.get_company.map((c) => ({
          value: c.id,
          label: c.company_name,
        }));

        // Add "All" option at the beginning
        setCompanies([{ value: "", label: "All" }, ...formatted]);
      } catch (error) {}
    };

    fetchCompanies();
  }, []);

  return companies;
};
